export default __webpack_public_path__ + "static/media/api_preview.f1de00e6.jpg";